import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  HostListener,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProfileService } from './../../services/profile.service';

import { PlanningTuning } from '@shared/models/planningTuning.model';
import { PlanningTuningLogs } from '@shared/models/planningTuningLogs.model';
import { PlanningTuningStats } from '@shared/models/planningTuningStats.model';
import { Profile } from '@shared/models/profile.model';
import { Scenario } from '@shared/models/scenario.model';
import { CampaignsService } from '@shared/services/campaigns.service';
import { ErrorService } from '@shared/services/error.service';
import { ExportService } from '@shared/services/export.service';
import { InstanceIdService } from '@shared/services/instance-id.service';
import { PlanningTuningService } from '@shared/services/planningTuning.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import moment from 'moment';
import { posthog } from 'posthog-js';

@Component({
  selector: 'app-adjust-planning-popup',
  standalone: false,
  templateUrl: './adjust-planning-popup.component.html',
  styleUrls: ['./adjust-planning-popup.component.scss'],
})
export class AdjustPlanningPopupComponent implements OnInit {
  public instanceId: string;

  public configForm: FormGroup;

  public endDate: moment.Moment;

  public minDate: Date;

  public startDate: moment.Moment;

  public formatedEndDate: string;

  public formatedStartDate: string;

  public validate: boolean = false;

  public savedConfigurations: PlanningTuning[] = [];

  public allConfigurations: PlanningTuning[] = [];

  public selectedConfigId: string = 'new';

  public positions: any = [];

  public selectedPositions: any[] = [];

  public searchValue: string | undefined;

  public profiles: Profile[] = [];

  public allProfiles: Profile[] = [];

  public profilesFormElements: any;

  public allSelected: boolean = false;

  public profilesLoaded: boolean = false;

  public showSaveDialog: boolean = false;

  public configurationName: string = '';

  public scenario: Scenario | undefined;

  public savedConfiguration: PlanningTuning | undefined;

  public titles: string[] = [];

  public isDuplicateName: boolean = false;

  public PlanningTuningLogsData: PlanningTuningLogs[] = [];

  public PlanningTuningStatsData: PlanningTuningStats | undefined;

  public needsCoverage: any[] = [];

  public profilsWithExchanges: any;

  public profilsWithOverTime: any;

  public profilesWithHours: any;

  public showOvertimeTooltip: boolean = false;

  public showExchangeTooltip: boolean = false;

  public showVacatairesTooltip: boolean = false;

  public showReasonsMapsTooltip: boolean = false;

  public showVacatairesMoyTooltip: boolean = false;

  public showReasonsMapsAfterTooltip: boolean = false;

  public isReasonsMapsLocked: boolean = false;

  public isVacatairesLocked: boolean = false;

  public isVacatairesMoyLocked: boolean = false;

  public isReasonsMapsAfterLocked: boolean = false;

  public isOvertimeLocked: boolean = false;

  public isExchangeLocked: boolean = false;

  public nbConversions: number = 0;

  public nbEchanges: number = 0;

  @Output() public onDataGenerated = new EventEmitter<any>();

  @ViewChild('datePicker') public datePicker: any;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<AdjustPlanningPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private planningTuningService: PlanningTuningService,
    private campaignsService: CampaignsService,
    private subscriptionManager: SubscriptionManager,
    private destroyRef: DestroyRef,
    private instanceIdService: InstanceIdService,
    private profileService: ProfileService,
    private exportService: ExportService,
    private errorService: ErrorService
  ) {
    this.profilesLoaded = false;
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);

    this.configForm = this.fb.group({
      reasonsMapsExchange:
        this.data.config?.reasonsMapsExchange !== undefined ? [this.data.config?.reasonsMapsExchange] : [true],
      keepRestDaysIntact:
        this.data.config?.keepRestDaysIntact !== undefined ? [this.data.config?.keepRestDaysIntact] : [false],
      allowOvertimeHours:
        this.data.config?.allowOvertimeHours !== undefined ? [this.data.config?.allowOvertimeHours] : [true],
      callVacataires: this.data.config?.callVacataires !== undefined ? [this.data.config?.callVacataires] : [false],
      maxOvertimeHours: this.data.config?.maxOvertimeHours
        ? [this.data.config?.maxOvertimeHours]
        : [5, [Validators.min(1), Validators.max(10)]],
      maxOvertimeMinutes: this.data.config?.maxOvertimeMinutes
        ? [this.data.config?.maxOvertimeMinutes]
        : [0, [Validators.min(0), Validators.max(59)]],
      positions: this.data.config?.positions !== undefined ? [this.data.config?.positions] : [[]],
      profileIds: this.data.config?.profileIds !== undefined ? [this.data.config?.profileIds] : [[]],
    });

    if (this.data.config?.fromDate) {
      this.startDate = moment(this.data.config.fromDate);
      this.endDate = moment(this.data.config.toDate);
    } else {
      if (this.data.fromDate && this.data.toDate) {
        this.startDate = moment(this.data.fromDate);
        this.endDate = moment(this.data.toDate);
      } else {
        this.startDate = moment().startOf('isoWeek');
        this.endDate = moment().endOf('isoWeek');
      }
    }
    if (this.data.config?.name) {
      this.configurationName = this.data.config.name;
    }
    if (this.data.config?._id) {
      this.selectedConfigId = this.data.config._id;
    }
    if (this.data.config?.positions) {
      this.selectedPositions = this.data.config?.positions;
    }

    this.formatedStartDate = this.startDate.format('YYYY-MM-DD');
    this.formatedEndDate = this.endDate.format('YYYY-MM-DD');
    this.minDate = new Date(this.formatedStartDate);
    this.validate = this.data?.validate || false;
  }

  ngOnInit(): void {
    if (this.data && this.data.config && this.data.config._id) {
      this.getPlanningTuningStats(this.data.config._id);
      this.getPlanningTuningLogs(this.data.config._id);
      this.getNeedsCoverage(this.data.config._id);
    }
    this.positions = this.constructPostes(this.data.positions);
    if (this.data.config?.positions && Array.isArray(this.data.config.positions)) {
      this.positions.forEach((p: any) => {
        p.isChecked = this.data.config.positions.includes(p.label);
      });
      this.selectedPositions = this.positions.filter((p: any) => p.isChecked);
    }
    this.loadSavedConfigurations();
    this.getScenarios();
    this.getProfiles();
  }

  getScenarios() {
    this.subscriptionManager
      .createRequest(this.campaignsService.getScenarios(this.data.hospital), 'getScenarios', this.instanceId)
      .subscribe({
        next: (scenarios: Scenario[]) => {
          if (scenarios && scenarios.length > 0) {
            this.scenario = scenarios[0];
          }
        },
        error: (error: any) => {
          console.error('Error loading scenarios:', error);
        },
      });
  }

  constructPostes(positions: string[]): any[] {
    const postes = [];

    for (const formation of positions) {
      postes.push({
        label: formation,
        value: `${(formation ?? '').slice(0, 1).toUpperCase()}${(formation ?? '').slice(1).toLowerCase()}`,
        isChecked: true,
        isDisabled: false,
      });
    }
    return postes;
  }

  toggleTooltip(
    tooltipName: 'overtime' | 'exchange' | 'reasonsMaps' | 'vacataires' | 'vacatairesMoy' | 'reasonsMapsAfter',
    event?: Event
  ) {
    if (event) {
      event.stopPropagation();
    }

    if (tooltipName !== 'overtime') {
      this.isOvertimeLocked = false;
      this.showOvertimeTooltip = false;
    }
    if (tooltipName !== 'exchange') {
      this.isExchangeLocked = false;
      this.showExchangeTooltip = false;
    }
    if (tooltipName !== 'reasonsMaps') {
      this.isReasonsMapsLocked = false;
      this.showReasonsMapsTooltip = false;
    }
    if (tooltipName !== 'vacataires') {
      this.isVacatairesLocked = false;
      this.showVacatairesTooltip = false;
    }
    if (tooltipName !== 'vacatairesMoy') {
      this.isVacatairesMoyLocked = false;
      this.showVacatairesMoyTooltip = false;
    }
    if (tooltipName !== 'reasonsMapsAfter') {
      this.isReasonsMapsAfterLocked = false;
      this.showReasonsMapsAfterTooltip = false;
    }

    switch (tooltipName) {
      case 'overtime':
        this.isOvertimeLocked = !this.isOvertimeLocked;
        this.showOvertimeTooltip = this.isOvertimeLocked;
        break;

      case 'exchange':
        this.isExchangeLocked = !this.isExchangeLocked;
        this.showExchangeTooltip = this.isExchangeLocked;
        break;

      case 'reasonsMaps':
        this.isReasonsMapsLocked = !this.isReasonsMapsLocked;
        this.showReasonsMapsTooltip = this.isReasonsMapsLocked;
        this.showReasonsMapsAfterTooltip = false;
        break;

      case 'vacataires':
        this.isVacatairesLocked = !this.isVacatairesLocked;
        this.showVacatairesTooltip = this.isVacatairesLocked;
        break;

      case 'vacatairesMoy':
        this.isVacatairesMoyLocked = !this.isVacatairesMoyLocked;
        this.showVacatairesMoyTooltip = this.isVacatairesMoyLocked;
        this.showVacatairesTooltip = this.isVacatairesMoyLocked;
        break;

      case 'reasonsMapsAfter':
        this.isReasonsMapsAfterLocked = !this.isReasonsMapsAfterLocked;
        this.showReasonsMapsAfterTooltip = this.isReasonsMapsAfterLocked;
        this.showReasonsMapsTooltip = this.isReasonsMapsAfterLocked;
        break;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.stat-card-wrapper')) {
      this.isOvertimeLocked = false;
      this.isExchangeLocked = false;
      this.isReasonsMapsLocked = false;
      this.isVacatairesLocked = false;
      this.isVacatairesMoyLocked = false;
      this.isReasonsMapsAfterLocked = false;
      this.showOvertimeTooltip = false;
      this.showExchangeTooltip = false;
      this.showReasonsMapsTooltip = false;
      this.showVacatairesTooltip = false;
      this.showVacatairesMoyTooltip = false;
      this.showReasonsMapsAfterTooltip = false;
    }
  }

  getProfiles() {
    this.profilesLoaded = false;
    const formations = JSON.stringify(this.data.accessOptionPositions);
    this.subscriptionManager
      .createRequest(
        this.profileService.getProfilesByPosition(
          'All',
          1,
          7,
          '',
          true,
          true,
          undefined,
          !this.data?.positions?.includes('Anesthésiste') ? undefined : 'Senior, Junior, Interne',
          false,
          false,
          false,
          undefined,
          formations,
          undefined
        ),
        'getProfiles',
        this.instanceId
      )
      .subscribe({
        next: (result: any) => {
          if (result && result.docs && result.docs.length > 0) {
            this.allProfiles = result.docs;
            this.profiles = result.docs;
            this.profiles.forEach((profile: any) => {
              profile.checked = true;
            });
            this.initForm();

            if (this.selectedConfigId && this.selectedConfigId !== 'new') {
              const config = this.savedConfigurations.find((c) => c._id === this.selectedConfigId);
              if (config && config.profileIds) {
                this.profiles.forEach((profile: any) => {
                  profile.checked = config.profileIds.includes(profile._id);
                });
                this.initForm();
              }
            }
          }
          this.profilesLoaded = true;
        },
        error: (error: any) => {
          console.error('Error loading profiles:', error);
          this.profilesLoaded = true;
        },
      });
  }

  initForm() {
    if (Array.isArray(this.profiles)) {
      this.profilesFormElements = [
        { label: 'Tout sélectionner', value: 'all', isChecked: this.profiles.every((el: any) => el.checked) },
      ];
      for (const profile of this.profiles) {
        this.profilesFormElements.push({
          label:
            `${this.capitalize(profile.firstName ?? '')} ${this.capitalize(profile.lastName ?? '')} - ` +
            profile.position,
          isChecked: profile.checked,
          value: profile._id,
        });
      }
    }
  }

  onProfilesSelectionChange(isChecked: boolean, value: string) {
    if (value === 'all' && isChecked && !this.allSelected) {
      this.profiles.forEach((profile: any) => {
        profile.checked = true;
      });
      this.profilesFormElements.forEach((profile: any) => {
        profile.isChecked = true;
      });

      this.allSelected = true;
      return;
    }

    if (value === 'all' && !isChecked && this.allSelected) {
      this.allSelected = false;
      this.profiles.forEach((profile: any) => {
        profile.checked = false;
      });
      this.profilesFormElements.forEach((profile: any) => {
        profile.isChecked = false;
      });
      return;
    }

    if (
      this.allSelected &&
      (!this.profilesFormElements.every((profileElement: any) => profileElement.isChecked) || !isChecked)
    ) {
      this.allSelected = false;
      this.profilesFormElements.find((profileElement: any) => profileElement.value === 'all').isChecked = false;
    }

    this.profiles.forEach((profile: any) => {
      profile.checked =
        value === profile._id
          ? isChecked
          : this.profilesFormElements.find((profile2: any) => profile2.value === profile._id) &&
            this.profilesFormElements.find((profile2: any) => profile2.value === profile._id).isChecked;
    });

    this.positions.forEach((poste: any) => {
      if (this.profiles.find((profile: any) => profile.checked && profile.position === poste.label)) {
        poste.isChecked = true;
      } else {
        poste.isChecked = false;
      }
    });
  }

  doFilterKeyUp(event: KeyboardEvent) {
    const value = (event.target as HTMLInputElement).value;
    this.doFilter(value);
  }

  doFilter(value: any) {
    const profilesToFilter = [...this.allProfiles];

    this.profiles = profilesToFilter.filter((profile: any) => {
      const re = new RegExp(value, 'gi');
      return profile.firstName.match(re) != null || profile.lastName.match(re) != null;
    });

    this.allSelected = this.profiles.every((profile: any) => profile.checked);
    this.initForm();
  }

  capitalize(s: string): string {
    const text = s.toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  onPositionsChange(selectedPositions: any) {
    const selectedPositionLabels = selectedPositions.map((elt: any) => elt.toLowerCase());

    this.profiles.forEach((profile: any) => {
      if (selectedPositionLabels.includes(profile.position.toLowerCase())) {
        profile.checked = true;
      } else {
        profile.checked = false;
      }
    });

    this.initForm();
  }

  getPlanningTuningStats(selectedConfigId: string | undefined) {
    if (selectedConfigId) {
      this.subscriptionManager
        .createRequest(
          this.planningTuningService.getPlanningTuningStats(selectedConfigId),
          'getPlanningTuningStats',
          this.instanceId
        )
        .subscribe({
          next: (result: PlanningTuningStats) => {
            if (result) {
              this.PlanningTuningStatsData = result;
            }
          },
          error: (error: any) => {
            console.error('Error loading stats:', error);
          },
        });
    }
  }

  getPlanningTuningLogs(selectedConfigId: string | undefined) {
    if (selectedConfigId) {
      this.subscriptionManager
        .createRequest(
          this.planningTuningService.getPlanningTuningLogs(selectedConfigId),
          'getPlanningTuningLogs',
          this.instanceId
        )
        .subscribe({
          next: (result: PlanningTuningLogs[]) => {
            if (result && result.length > 0) {
              this.PlanningTuningLogsData = result;
              this.getVacataires();
              this.getHeuresSupp();
              this.getEchanges();
            }
          },
          error: (error: any) => {
            console.error('Error loading planning logs:', error);
          },
        });
    }
  }

  getNeedsCoverage(selectedConfigId: string | undefined) {
    if (selectedConfigId) {
      this.subscriptionManager
        .createRequest(
          this.planningTuningService.getNeedsCoverage(selectedConfigId),
          'getNeedsCoverage',
          this.instanceId
        )
        .subscribe({
          next: (result: any[]) => {
            if (result && result.length > 0) {
              this.needsCoverage = result;
            }
          },
          error: (error: any) => {
            console.error('Error loading needs coverage:', error);
          },
        });
    }
  }

  loadSavedConfigurations(): void {
    this.subscriptionManager
      .createRequest(
        this.planningTuningService.getPlanningConfigs(this.data.hospital, this.formatedStartDate, this.formatedEndDate),
        'getPlanningConfigs',
        this.instanceId
      )
      .subscribe({
        next: (configs: PlanningTuning[]) => {
          this.titles = configs.map((elt: any) => elt.name.trim().toLowerCase());
          this.allConfigurations = configs.filter((elt: any) => elt.exported === false);
          this.filterConfigurationsByDate();
        },
        error: (error: any) => {
          console.error('Error loading configurations:', error);
        },
      });
  }

  checkDuplicateName() {
    this.isDuplicateName = this.titles.includes(this.configurationName.trim().toLowerCase());
  }

  onConfigurationSelect(configId: string): void {
    if (!configId || configId === 'new') {
      this.configForm.patchValue({
        reasonsMapsExchange: true,
        allowOvertimeHours: true,
        callVacataires: false,
        keepRestDaysIntact: false,
        maxOvertimeHours: 5,
        maxOvertimeMinutes: 0,
      });
      this.configurationName = '';
      this.selectedPositions = [];
      this.positions.forEach((p: any) => {
        p.isChecked = false;
        p.isDisabled = false;
      });
      this.profiles.forEach((p: any) => (p.checked = false));
      this.initForm();
      return;
    }

    const config = this.savedConfigurations.find((c) => c._id === configId);
    if (config) {
      this.getPlanningTuningStats(config._id);
      this.getPlanningTuningLogs(config._id);
      this.getNeedsCoverage(config._id);
      this.configForm.patchValue({
        reasonsMapsExchange: config.reasonsMapsExchange,
        allowOvertimeHours: config.allowOvertimeHours,
        callVacataires: config.callVacataires,
        maxOvertimeHours: config.maxOvertimeHours,
        maxOvertimeMinutes: config.maxOvertimeMinutes,
        keepRestDaysIntact: config.keepRestDaysIntact,
      });
      this.configurationName = config.name;
      this.startDate = moment(config.fromDate);
      this.endDate = moment(config.toDate);
      this.generateFormatedDates(this.startDate, this.endDate);

      if (config.positions && Array.isArray(config.positions)) {
        this.positions.forEach((p: any) => {
          p.isChecked = config.positions.includes(p.label);
        });
        this.selectedPositions = this.positions.filter((p: any) => p.isChecked);
      }

      if (config.profileIds && Array.isArray(config.profileIds)) {
        this.profiles.forEach((profile: any) => {
          profile.checked = config.profileIds.includes(profile._id);
        });
        this.initForm();

        this.positions.forEach((poste: any) => {
          if (this.profiles.find((profile: any) => profile.checked && profile.position === poste.label)) {
            poste.isChecked = true;
          }
        });
      }

      if (this.datePicker) {
        this.datePicker.startDay = this.formatedStartDate;
        this.datePicker.endDay = this.formatedEndDate;
      }
    }
  }

  validatePlanning() {
    const config = this.savedConfigurations.find((c) => c._id === this.selectedConfigId);
    if (config) {
      const scenario = config.scenario;
      const planningId = config._id;
      const dataToReturn = {
        scenario: scenario,
        planningId: planningId,
        isValidate: true,
      };
      this.onDataGenerated.emit(dataToReturn);
    }
  }

  visualizePlanning() {
    const config = this.savedConfigurations.find((c) => c._id === this.selectedConfigId);
    if (config) {
      const url_liste = `${window.location.origin}/hrsuite/liste?scenario=${config.scenario}&campaign=${config._id}&adjustment=true`;
      window.open(url_liste, '_blank');
    }
  }

  exportPlanning() {
    posthog.capture('Download_Adjustment_Planning', { page_source: 'HRSuite_list' });
    const config = this.savedConfigurations.find((c) => c._id === this.selectedConfigId);
    if (config) {
      const scenario = String(config.scenario);
      const planningId = config._id;
      if (planningId && scenario) {
        this.subscriptionManager
          .createRequest(
            this.campaignsService.generateExcelReport(planningId, scenario, true),
            'generateExcelReport',
            this.instanceId
          )
          .subscribe({
            next: (res: any) => {
              const nightData = res.nightData.sort((a: any, b: any) => a._id.localeCompare(b._id));
              const dayData = res.dayData.sort((a: any, b: any) => a._id.localeCompare(b._id));
              this.exportService.saveExcel1(dayData, nightData, ['DAY'], 'adjustment_planning');
            },

            error: (error: any) => {
              this.errorService.handleError(error);
            },
          });
      }
    }
  }

  saveConfiguration(): void {
    const selectedPositionsList = this.positions.filter((p: any) => p.isChecked).map((p: any) => p.label);

    const config: PlanningTuning = {
      name: this.configurationName,
      reasonsMapsExchange: this.configForm.value.reasonsMapsExchange,
      keepRestDaysIntact: this.configForm.value.keepRestDaysIntact,
      allowOvertimeHours: this.configForm.value.allowOvertimeHours,
      callVacataires: this.configForm.value.callVacataires,
      maxOvertimeHours: this.configForm.value.maxOvertimeHours,
      maxOvertimeMinutes: this.configForm.value.maxOvertimeMinutes,
      fromDate: new Date(this.formatedStartDate),
      toDate: new Date(this.formatedEndDate),
      hospital: this.data.hospital,
      positions: selectedPositionsList,
      profileIds: this.profiles.filter((elt) => elt.checked).map((elt: any) => elt._id),
      scenario: this.scenario ?? null,
    };

    if (this.selectedConfigId && this.selectedConfigId !== 'new') {
      config._id = this.selectedConfigId;
      this.subscriptionManager
        .createRequest(
          this.planningTuningService.updatePlanningTuningConfig(config),
          'updatePlanningTuningConfig',
          this.instanceId
        )
        .subscribe({
          next: (updatedConfig) => {
            this.savedConfiguration = updatedConfig;
            const index = this.savedConfigurations.findIndex((c) => c._id === this.selectedConfigId);
            if (index !== -1) {
              this.savedConfigurations[index] = updatedConfig;
            }
            this.showSaveDialog = false;
          },
          error: (error) => {
            console.error('Error updating configuration:', error);
          },
        });
    } else {
      this.subscriptionManager
        .createRequest(
          this.planningTuningService.addPlanningTuningConfig(config),
          'addPlanningTuningConfig',
          this.instanceId
        )
        .subscribe({
          next: (savedConfig) => {
            this.savedConfiguration = savedConfig;
            this.onGenerate(this.savedConfiguration);
            this.savedConfigurations.push(savedConfig);
            this.allConfigurations.push(savedConfig);
            if (savedConfig._id) {
              this.selectedConfigId = savedConfig._id;
            }
            this.changeDetectorRef.detectChanges();
            this.showSaveDialog = false;
          },
          error: (error) => {
            console.error('Error saving configuration:', error);
          },
        });
    }
  }

  isAdjustButtonDisabled(): boolean {
    if (this.selectedConfigId === 'new') {
      return !this.configurationName?.trim() || this.isDuplicateName;
    }
    return false;
  }

  closePopup(): void {
    this.dialogRef.close();
  }

  onGenerate(savedConfig: any): void {
    const dataToReturn = {
      ...savedConfig,
      startDate: this.startDate.format('YYYY-MM-DD'),
      endDate: this.endDate.format('YYYY-MM-DD'),
    };
    this.onDataGenerated.emit(dataToReturn);
  }

  filterConfigurationsByDate(): void {
    const startDate = moment(this.formatedStartDate).startOf('day');
    const endDate = moment(this.formatedEndDate).startOf('day');

    this.savedConfigurations = this.allConfigurations.filter((config: any) => {
      const configStart = moment(config.fromDate).startOf('day');
      const configEnd = moment(config.toDate).startOf('day');

      if (startDate.isSame(endDate, 'day')) {
        return configStart.isSameOrBefore(startDate, 'day') && configEnd.isSameOrAfter(startDate, 'day');
      }

      return configStart.isSameOrBefore(endDate, 'day') && configEnd.isSameOrAfter(startDate, 'day');
    });
  }

  onDateChange(data: { startDate: Date; endDate: Date }): void {
    this.startDate = moment.utc(moment(data.startDate).format('YYYY-MM-DD'));
    this.endDate = moment.utc(moment(data.endDate).format('YYYY-MM-DD'));

    this.generateFormatedDates(this.startDate, this.endDate);
    this.filterConfigurationsByDate();
  }

  generateFormatedDates(startDate: moment.Moment, endDate: moment.Moment): void {
    this.formatedStartDate = startDate.format('YYYY-MM-DD');
    this.formatedEndDate = endDate.format('YYYY-MM-DD');
    this.minDate = new Date(this.formatedStartDate);
  }

  getVacataires(): void {
    const vacataires = this.PlanningTuningLogsData.filter((elt: any) => elt.isVacataire);
    const profilsvacataires = vacataires.reduce((acc: Map<string, any[]>, elt: any) => {
      const profileId = elt.profile._id;
      if (!acc.has(profileId)) {
        acc.set(profileId, []);
      }
      acc.get(profileId)!.push(elt);
      return acc;
    }, new Map<string, any[]>());
    const profilesWithHours = Array.from<[string, any[]]>(profilsvacataires).map(([_, entries]) => {
      const totalHours = entries.reduce((sum: any, entry: any) => {
        if (entry.reasonMapActual) {
          const morningStart = new Date(entry.reasonMapActual.morningStartTime);
          const afternoonEnd = new Date(entry.reasonMapActual.afternoonEndTime);
          const diffHours = (afternoonEnd.getTime() - morningStart.getTime()) / (1000 * 60 * 60);
          return sum + diffHours;
        }
        return sum;
      }, 0);

      return {
        profile: entries[0].profile,
        totalHours: totalHours,
      };
    });
    this.profilesWithHours = profilesWithHours;
  }

  getHeuresSupp(): void {
    const heuresSupp = this.PlanningTuningLogsData.filter((elt: any) => elt.isTimeExtention);
    const profilOverTime = heuresSupp.reduce((acc: Map<string, any[]>, elt: any) => {
      const profileId = elt.profile._id;
      if (!acc.has(profileId)) {
        acc.set(profileId, []);
      }
      acc.get(profileId)!.push(elt);
      return acc;
    }, new Map<string, any[]>());
    const profilsWithOverTime = Array.from<[string, any[]]>(profilOverTime).map(([_, entries]) => {
      const totalHours = entries.reduce((sum: any, entry: any) => {
        if (entry.reasonMapActual) {
          const morningStart1 = new Date(entry.reasonMapInitial.morningStartTime);
          const afternoonEnd1 = new Date(entry.reasonMapInitial.afternoonEndTime);
          const duration1 = (afternoonEnd1.getTime() - morningStart1.getTime()) / (1000 * 60 * 60);

          const morningStart2 = new Date(entry.reasonMapActual.morningStartTime);
          const afternoonEnd2 = new Date(entry.reasonMapActual.afternoonEndTime);
          const duration2 = (afternoonEnd2.getTime() - morningStart2.getTime()) / (1000 * 60 * 60);

          const diffHours = Math.abs(duration2 - duration1);
          return sum + diffHours;
        }
        return sum;
      }, 0);

      return {
        profile: entries[0].profile,
        timeExtension: totalHours,
      };
    });
    this.profilsWithOverTime = profilsWithOverTime;
  }

  getEchanges(): void {
    const echanges = this.PlanningTuningLogsData.filter((elt: any) => elt.isEchange || elt.isConversion);

    const profilsEchanges = echanges.reduce((acc: Map<string, any[]>, elt: any) => {
      const profileId = String(elt.profile._id);
      if (!acc.has(profileId)) {
        acc.set(profileId, []);
      }
      acc.get(profileId)!.push(elt);
      return acc;
    }, new Map<string, any[]>());

    const profilsWithExchanges = Array.from<[string, any[]]>(profilsEchanges).map(([_, entries]) => {
      let nbEchanges = 0;
      let nbConversions = 0;

      for (const echange1 of entries) {
        const echange2 = echange1.isEchange;

        if (echange2) {
          nbEchanges++;
        } else {
          nbConversions++;
        }
      }
      this.nbEchanges += nbEchanges;
      this.nbConversions += nbConversions;

      return {
        profile: entries[0].profile,
        nbEchanges: nbEchanges / 2,
        nbConversions,
      };
    });

    this.profilsWithExchanges = profilsWithExchanges;
  }

  convertHoursToHM(hours: number): string {
    const h = Math.floor(hours);
    const minutes = Math.round((hours - h) * 60);

    if (minutes === 0) {
      return `${h}h`;
    }

    return `${h}h ${minutes}min`;
  }

  formatNumber(value: number): number {
    if (value > 0 && value < 1) {
      return Math.ceil(value);
    }
    return Math.floor(value);
  }

  public get reasonsMapsExchange() {
    return this.configForm.get('reasonsMapsExchange')?.value;
  }

  public set reasonsMapsExchange(value: boolean) {
    this.configForm.patchValue({ reasonsMapsExchange: value });
  }

  public get keepRestDaysIntact() {
    return this.configForm.get('keepRestDaysIntact')?.value;
  }

  public set keepRestDaysIntact(value: boolean) {
    this.configForm.patchValue({ keepRestDaysIntact: value });
  }

  public get allowOvertimeHours() {
    return this.configForm.get('allowOvertimeHours')?.value;
  }

  public set allowOvertimeHours(value: boolean) {
    this.configForm.patchValue({ allowOvertimeHours: value });
  }

  public get callVacataires() {
    return this.configForm.get('callVacataires')?.value;
  }

  public set callVacataires(value: boolean) {
    this.configForm.patchValue({ callVacataires: value });
  }

  public get maxOvertimeHours() {
    return this.configForm.get('maxOvertimeHours')?.value;
  }

  public set maxOvertimeHours(value: number) {
    this.configForm.patchValue({ maxOvertimeHours: value });
  }

  public get maxOvertimeMinutes() {
    return this.configForm.get('maxOvertimeMinutes')?.value;
  }

  public set maxOvertimeMinutes(value: number) {
    this.configForm.patchValue({ maxOvertimeMinutes: value });
  }
}
